import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { OfflineReportState } from '../../typings/graphql-grid';
import { ReportStatus } from '../../typings/reports';

import './ReportsStatusCell.css';
import * as keyset from './ReportsStatusCell.i18n';

const i18n = i18nFactory(keyset);

export interface ReportsStatusCellProps {
    status: ReportStatus | OfflineReportState;
}

export class ReportsStatusCell extends React.PureComponent<ReportsStatusCellProps> {
    render() {
        const { status } = this.props;
        let statusText: string;
        switch (status) {
            case ReportStatus.new:
                statusText = i18n('new');
                break;
            case ReportStatus.error:
                statusText = i18n('error');
                break;
            case ReportStatus.processing:
                statusText = i18n('processing');
                break;
            case ReportStatus.ready:
            default:
                statusText = i18n('ready');
                break;
        }

        return (
            <div
                className={Bem.cls({
                    block: 'reports-status-cell',
                    mods: { theme: status.toLowerCase() }
                })}
            >
                {statusText}
            </div>
        );
    }
}
